const FileListTabMode = {
  DOCUMENT: 0,
  SHARED_USERS_OF_DOCUMENT: 1,
  PROGRESS: 2,
  ESIGN: 3
}

export default FileListTabMode;
